/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, useRef} from 'react'
import {Link, useParams} from 'react-router-dom'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {approve, resetpassword} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useIntl} from 'react-intl'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

const initialValues = {
  guid: '',
  password: '',
  changepassword: '',
}

export function ResetPage() {
  const {approvalGuid} = useParams()
  const intl = useIntl()
  const changepasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(3, useIntl().formatMessage({id: 'Minimum_3_symbols'}))
      .max(50, useIntl().formatMessage({id: 'Maksimum_50_symbols'}))
      .required(useIntl().formatMessage({id: 'Password_is_required'})),
    changepassword: Yup.string()
      .required(useIntl().formatMessage({id: 'Password_is_required'}))
      .when('password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref('password')],
          "Password and Confirm Password didn't match"
        ),
      }),
  })
  const lang = useLang()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [approvedText, setApprovedText] = useState('')
  const {saveAuth, setCurrentUser} = useAuth()

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: changepasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await resetpassword(approvalGuid || '', values.password)
        swal
          .fire({
            title: intl.formatMessage({
              id: 'Success',
            }),
            text: intl.formatMessage({id: 'Your password updated succesfully!'}),
            icon: 'success',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
          .then((result) => {
            if (result.isConfirmed) {
              navigate('/auth/login')
            }
          })
        //console.log(auth.status)
        /*if (auth.status === "Error") {
                    console.error(auth.message)
                    saveAuth(undefined)
                    setStatus(auth.message)
                    setSubmitting(false)
                    setLoading(false)
                }
                else {
                    saveAuth(auth)
                    const { data: user } = await getUserByToken()
                    setCurrentUser(user)
                }*/
      } catch (error: any) {
        //console.error(error)
        if (error.response && error.response.data && error.response.data.message) {
          // Formik hata durumunu göster
          setStatus(error.response.data.message)
        } else {
          setStatus('Bir hata oluştu, lütfen tekrar deneyin.')
        }
        saveAuth(undefined)
        //setStatus()
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <>
      <p className='w-100 text-center m-2 text-dark fw-bolder'>
        {intl.formatMessage({id: 'Enter_New_Password'})}
      </p>

      {/* Hata mesajlarını burada gösterebiliriz */}
      {formik.status && (
        <div className='alert alert-danger'>
          <strong>{formik.status}</strong>
        </div>
      )}

      <form id='formikform' className='form' onSubmit={formik.handleSubmit} noValidate>
        <div className='mb-10 fv-row' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>
              {useIntl().formatMessage({id: 'Password'})}
            </label>
            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder={useIntl().formatMessage({id: 'Password'})}
                autoComplete='off'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}
          </div>
          <div className='text-muted'>
            {useIntl().formatMessage({
              id: 'Use 8 or more characters with a mix of letters, numbers & symbols.',
            })}
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-7'>
          <label className='form-label fw-bolder text-dark fs-6'>
            {useIntl().formatMessage({id: 'Confirm Password'})}
          </label>
          <input
            type='password'
            placeholder={useIntl().formatMessage({id: 'Confirm Password'})}
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
              },
              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
              }
            )}
          />
          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{intl.formatMessage({id: formik.errors.changepassword})}</span>
              </div>
            </div>
          )}
        </div>
        {/* <button
                    type='submit'
                    id='kt_login_signup_form_button'
                    className='btn btn-lg btn-light-primary w-100 mb-5'
                >
                    {useIntl().formatMessage({ id: 'Send' })}
                </button> */}
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary  w-100  mt-2'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className='indicator-label'>{intl.formatMessage({id: 'Submit'})}</span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'Please_wait'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </form>
    </>
  )
}
